import { authGlobalApiClient } from '@api-client/auth_global';
import type { ResType } from '@api-client/typeUtils';

type IpWhoResponse = ResType<typeof authGlobalApiClient.ipwhois['$get']>["data"];

export const ipwhois = async (): Promise<IpWhoResponse> => {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
        const cacheKey = 'ipwhois_ver_260302';
        const cachedResult = sessionStorage.getItem(cacheKey);

        // If we have a cached result and it's not expired, return it
        if (cachedResult) {
            try {
                const { data, timestamp } = JSON.parse(cachedResult) as { data: IpWhoResponse, timestamp: number };
                // Check if the cache is still valid (3 hours = 10800000 ms)
                if (Date.now() - timestamp < 10_800_000) {
                    return data;
                }
            } catch (error) {
                // If there's an error parsing the cached data, ignore it and fetch fresh data
                console.error('Error parsing cached ipwhois data:', error);
            }
        }

        // If no valid cache exists, fetch new data
        const result = (await (await authGlobalApiClient.ipwhois.$get()).json()).data;

        // Cache the result in sessionStorage
        sessionStorage.setItem(cacheKey, JSON.stringify({
            data: result,
            timestamp: Date.now()
        }));

        return result;
    }

    // If not in browser, just fetch without caching
    return (await (await authGlobalApiClient.ipwhois.$get()).json()).data;
}